import AirAmbulanceForm from '../../../../AirAmbulanceForm';
import { FormContent } from './ResourceRequestPanel.styles';

function AirAmbulanceView() {
  return (
    <FormContent>
      <AirAmbulanceForm hideBackButton noBorder />
    </FormContent>
  );
}

export default AirAmbulanceView;
